import { Typography } from '@breetometer/components';

export const FilePreviewLoading = ({ loadText }: { loadText?: string }) => (
	<div className='loading-spinner'>
		<div className='spinner'></div>
		<Typography as='p'>{loadText ?? 'Loading'}...</Typography>
	</div>
);
